import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_MUTATION } from '../graphql/mutations'
import { transformToSaveIngredientCommonNegativeSynonymPhrasesArgs } from '../graphql/transformers'
import { SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES } from '../redux/action-types'

const useSaveIngredientCommonNegativeSynonymPhrasesMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredientCommonNegativeSynonymPhrases,
  )

  const mutate = useCallback(
    data =>
      apolloService.mutate(
        SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_MUTATION,
        {
          data: transformToSaveIngredientCommonNegativeSynonymPhrasesArgs(data),
        },
        dispatch,
        SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveIngredientCommonNegativeSynonymPhrasesMutation
